import { render, staticRenderFns } from "./DynamicPageRegistrationForm.vue?vue&type=template&id=35d118cc&scoped=true&"
import script from "./DynamicPageRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./DynamicPageRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPageRegistrationForm.vue?vue&type=style&index=0&id=35d118cc&scoped=true&lang=scss&"
import style1 from "./DynamicPageRegistrationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d118cc",
  null
  
)

export default component.exports